export const primaryColor = "#002e7d";
export const secondaryColor = "#0053a0";
export const rainbowColors = ["#d8353d", "#d8984f", "#1d8d4f", "#3877e4"];
//# sourceMappingURL=colors.js.map